'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var kumquat7 = exports.kumquat7 = '#C94727';
var kumquat6 = exports.kumquat6 = '#D85C29';
var kumquat5 = exports.kumquat5 = '#E8722C';
var kumquat4 = exports.kumquat4 = '#F98816';
var kumquat3 = exports.kumquat3 = '#FA9628';
var kumquat2 = exports.kumquat2 = '#FAA33A';
var kumquat1 = exports.kumquat1 = '#FBB04C';
var kumquat = {
  7: kumquat7,
  6: kumquat6,
  5: kumquat5,
  4: kumquat4,
  3: kumquat3,
  2: kumquat2,
  1: kumquat1
};
exports.default = kumquat;